import {
  BaseTable,
  Card,
  FooterMenu,
  HeaderMenu,
  Label,
  Loading,
  PaginationData,
  Select,
  TableHeader
} from "components"
import { useState } from "react"
import { APPROVAL_OPTIONS } from "utils"
import { Item, ModalExportApprovalOpeningStock } from "./components"
import { FilterState } from "./types"
import {
  defaultValue,
  exportExcel,
  useApprovalList,
  useExportPdf,
  useGetAllApproval
} from "./utils" 

export type IsOpenModal = {
  isOpen: boolean
  type: "excel" | "pdf" | "",
  amount: number
}
export default function ApprovalOpeningStock() {
  const [pagination, setPagination] = useState<FilterState>(defaultValue)
  const { data, isLoading, refetch } = useApprovalList(pagination)
  const getAllApproval = useGetAllApproval({ approval_status: Number(pagination?.approval_status) })
  const amount = Math.min(getAllApproval?.data?.length ?? 0, 10);
  const exportPdf = useExportPdf({ data: data?.payload })

  const [isOpenModal, setIsOpenModal] = useState<IsOpenModal>({
    isOpen: false,
    type: "",
    amount: 10
  })

  const handleExportExcel = () => {
    const slicedData = getAllApproval?.data?.slice(0, isOpenModal?.amount) ?? []
    exportExcel({ data: slicedData })
    setIsOpenModal({ isOpen: false, type: "", amount: 10 })
  }

  return (
    <section className="container my-2">
      <section>
        <HeaderMenu title="APPROVAL OPENING STOCK" />

        <section>
          <section className="mt-2">
            <Card>
              <Card.Body>
                <div className="justify-end lg:flex items-center">
                  <Label className="mr-2">APPROVAL</Label>
                  <Select
                    className="lg:w-[200px]"
                    placeholder="Select Approval"
                    options={APPROVAL_OPTIONS}
                    value={APPROVAL_OPTIONS.find(
                      (item) => item.value === pagination.approval_status
                    )}
                    onChange={(e) =>
                      setPagination({
                        ...pagination,
                        approval_status: e?.value
                      })
                    }
                  />
                </div>
              </Card.Body>
            </Card>
          </section>
        </section>

        <section className="mt-2">
          <Card>
            <Card.Body>
              <div className="overflow-x-auto">
                <BaseTable>
                  <TableHeader>
                    <tr>
                      <th>No</th>
                      <th colSpan={2}>DATE</th>
                      <th>LOCATION</th>
                      <th>ITEM</th>
                      <th>DESCRIPTION</th>
                      <th>STOCK</th>
                      <th>UNIT</th>
                      <th>STATUS</th>
                      <th>DATE APPROVE</th>
                    </tr>
                  </TableHeader>
                  <tbody>
                    {isLoading || data?.payload?.length === 0 ? (
                      <tr>
                        <td colSpan={12} className="text-center">
                          <Loading
                            loading={isLoading}
                            errorText={isLoading ? "" : "No data available"}
                          />
                        </td>
                      </tr>
                    ) : (
                      data?.payload?.map((item, key: number) => (
                        <Item
                          data={item}
                          index={key}
                          refetch={refetch}
                          pagination={pagination}
                        />
                      ))
                    )}
                  </tbody>
                </BaseTable>
              </div>
              <div className="mt-5">
                <PaginationData
                  data={data}
                  pagination={pagination}
                  setPagination={setPagination}
                />
              </div>
            </Card.Body>
          </Card>
        </section>

        <section className="mt-2">
          <FooterMenu
            export={{
              actiontype: "export",
              onClick: () => setIsOpenModal({ ...isOpenModal, isOpen: true, type: "excel", amount: amount })
            }}
            pdf={{
              actiontype: "pdf",
              onClick: () => exportPdf.handleExportPdf()
            }}
          />

          {/* Modal Export */}
          <ModalExportApprovalOpeningStock 
            label="Export Approval Opening Stock"
            show={isOpenModal.isOpen} 
            onHide={() => setIsOpenModal({ isOpen: false, type: "", amount: 10 })} 
            maxAmount={getAllApproval?.data?.length}
            amount={isOpenModal?.amount}
            setAmount={(amount) => setIsOpenModal({ ...isOpenModal, amount: amount })}
            onButtonExportClick={handleExportExcel}
          />
        </section>
      </section>
    </section>
  )
}
